import styled from 'styled-components';

const StyledQuickFilterWrapper = styled.div`
  display: flex;
  width: 65%;

  ${({ isPLPSortAndOneHrFilterRedesignEnabled }) =>
    isPLPSortAndOneHrFilterRedesignEnabled && 'width:auto; flex-shrink:0;'}
`;

export default StyledQuickFilterWrapper;
